<template>
  <div class="sections-holder">
    <FaqSection>
      <span slot="heading">
        What are the measures of central tendency?
      </span>
      <div slot="content">
        <p>Measures of central tendency show us the middle of the data’s distribution. In other words, they provide information about the central or typical value in a dataset. These measures are widely used because they are easy to compute and return a quick summary of the data.</p>
        <p>There are several measures of central tendency, but the most common ones are the mean, median, and mode. Let’s take a look at the definitions:</p>
        <ul>
          <li>The arithmetic mean is equal to the sum of all values divided by the number of observations. It’s the most used measure of central tendency, appropriate to use on normally distributed data or data without extreme values.</li>
          <li>The median is the middle value in a dataset sorted into ascending or descending order. If there is an even number of observations, we take the average of the two middle values. The median is useful when the data is skewed or contains outliers.</li>
          <li>The mode is the most frequently occurring value in a dataset. It’s the only measure of central tendency that can be used with nominal data.</li>
        </ul>
      </div>
    </FaqSection>
    <hr>
    <FaqSection>
      <span slot="heading">
        How to calculate the measures of central tendency in Excel?
      </span>
      <div slot="content">
        <p>We calculate the measures of central tendency in Excel using its built-in functions AVERAGE, MEDIAN, and MODE.SNGL.</p>
        <div v-for="(obj, i) in data" :key="i">
          <p>{{ obj.p }}</p>
          <img :src="require(`../../../../assets/images/calculators/mean-median-mode/mmm-faq-0${obj.imgNum}-desktop.png`)" :alt="obj.alt">
        </div>
        <p>Whichever calculation method you chose, make sure you double-check your result using the Mean, Median, Mode Calculator above.</p>
      </div>
    </FaqSection>
  </div>
</template>

<script>
import FaqSection from './Section.vue';

export default {
  components: {
    FaqSection,
  },
  data() {
    return {
      data: [
        {
          p: 'Let’s observe an example with the following dataset:',
          imgNum: 1,
          alt: 'Dataset image.',
        },
        {
          p: 'In Excel, type AVERAGE, then select the data contained in the cell range (C5:C14):',
          imgNum: 2,
          alt: 'Dataset in Excell with average in cell range (C5:C14).',
        },
        {
          p: 'By running the formula, we see that the arithmetic mean is equal to 38.80:',
          imgNum: 3,
          alt: 'Arithmetic mean is equal to 38.80.',
        },
        {
          p: 'Obtaining the median is also straightforward: simply use the MEDIAN function on the same cell range (C5:C14):',
          imgNum: 4,
          alt: 'Dataset in Excell with median in cell range (C5:C14).',
        },
        {
          p: 'And here, we see that the median is 0.11:',
          imgNum: 5,
          alt: 'Median is equal to 0.11.',
        },
        {
          p: 'The last step is to obtain the mode of the dataset. To do that, we will use MODE.SNGL. Type the function and select the same range as before:',
          imgNum: 6,
          alt: 'Using MODE.SNGL to find the mode.',
        },
        {
          p: 'This gives us exactly 23:',
          imgNum: 7,
          alt: 'Mode is equal to 23.',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.sections-holder {
  hr {
    margin: var(--spacing-8) 0 var(--spacing-24);
    border: 1px solid rgba(0, 12, 31, 0.12);
  }
}
</style>
